<template>
  <div>
    <b-row class="p-0 ranking-container pb-3 mb-0" align-h="end">
      <b-col cols="12  p-5" style="background:#191919">
        <h2>Jugadores más destacados</h2>
      </b-col>
      <b-col
        lg="12"
        md="12"
        sm="12"
        v-if="loadingTopRank"
        style="height:500px; margin-top:100px;"
        caption="loading"
      >
        <div class="col text-center">
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </b-col>
      <b-col
        v-else
        lg="3"
        md="6"
        sm="12"
        v-for="(item, index) in topRanking"
        v-bind:key="index"
        class="pb-5 pl-5 pt-5 this-right col-sm-12"
        :style=" isOdd(index) ? 'background: #000;' : 'background:#191919' "
      >
        <h3>{{item.title}}</h3>
        <b-row
          v-for="(player, index) in item.players"
          v-bind:key="index"
          class="mb-3"
          align-v="center"
        >
          <b-col cols="3" class="pr-0" style="text-align: center;">
            <b-img :src="player.urlImage" class="player-pic" />
          </b-col>
          <b-col cols="9">
            <p style="margin-bottom:0">
              {{player.name}}
              <br />
              <strong>Ranking: {{player.ranking}}</strong>
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <RankingBuscador id="ranking" :options="options" />
  </div>
</template>

<script>
import axios from "axios";
import RankingBuscador from "../components/RankingBuscador";
import config from "../../public/data/config.json"
export default {
  components: {
    RankingBuscador
  },
  data() {
    return {
      loadingTopRank: false,
      loading: false,
      loggedData: null,
      error: false,
      modalidad: null,
      options: [],
      categorias: null,
      categoriasOptions: [
        { value: null, text: "Categoría" },
        { value: "01", text: "Categoría 1" },
        { value: "02", text: "Categoría 2" },
        { value: "03", text: "Categoría 3" },
        { value: "04", text: "Categoría 4" }
      ],
      topRanking: []
    };
  },
  methods: {
    isOdd: function(index) {
      return index < 4 || index > 7; //index % 2 == 0 ;
    },
    async login() {
      const headers = {
        "Content-Type": "application/json"
      };
      const object = {
        user: "cta_web",
        password: "W9C*#C7rx.S4"
      };
      try {
        const resp = await axios.post(
          config.CTAURL+"/auth/login",
          object,
          headers
        );
        this.loggedData = resp.data;
        this.loading = false;
        return true;
      } catch (error) {
        this.loading = false;
        console.log(error);
        return false;
      }
    },
    async getRankings(modality, limit) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loggedData.access_token}`
      };

      const object = {
        modality: modality,
        limit: limit,
        skip: 0
      };
      try {
        const resp = await axios.post(
          config.CTAURL+"/ranking",
          object,
          { headers: headers }
        );
        return resp.data.players;
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    async getTopRankings() {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loggedData.access_token}`
      };
      try {
        const response = await axios.get(
          config.CTAURL+"/destacados",
          { headers: headers }
        );

        response.data.players.forEach(element => {
          this.topRanking.push({
            title: Object.keys(element)[0],
            players: element[Object.keys(element)]
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getModalities() {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.loggedData.access_token}`
      };
      try {
        const response = await axios.get(
          config.CTAURL+"/modalities ",
          { headers: headers }
        );
        this.options = response.data.modalities.map(item => {
          return {
            value: item.name,
            text: item.name
          };
        });
        return true;
      } catch (error) {
        console.log(error);
        return false;
      }
    }
  },
  async mounted() {
    this.loading = true;
    await this.login();
    await this.getModalities();
    this.loadingTopRank = true;
    await this.getTopRankings();
    this.loadingTopRank = false;
  }
};
</script>
<style scoped>
.rank-select {
  color: #fff;
  width: 200px;
  margin: auto;
  border: 0px solid;
  border-bottom: 1px solid white;
  border-radius: 0;
  background: #817f7f
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='white' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
}

.ranking-search {
  background: #817f7f;
  color: #fff;
  align-items: center;
}
.inner-ranking {
  /*display: flex;
  margin: auto; */
  align-items: center;
}
.ranking-container {
  background: black;
  color: #fff;
  justify-content: space-evenly;
  background-image: url(~@/assets/images/bgball.png);
  background-position-x: 50px;
  background-position-y: 95%;
  background-repeat: no-repeat;
  min-height: 600px;
  background-size: auto;
}
h2 {
  text-align: center;
  color: white;
}
h3 {
  font-size: 24px;
  text-align: center;
}
p {
  text-transform: uppercase;
}
.player-pic {
  border-radius: 40px;
  width: 100%;
  max-width: 60px;
  height: auto;
}
.this-right {
  border-right: 1px solid #3f3f3f;
}
</style>




